<template>
    <div class="form-item">
        <label class="label-caption">Situação SISBI</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'NÃO SOLICITADO' },
                { id: 2, descricao: 'SOLICITADO' },
                { id: 3, descricao: 'SUSPENSO' },
                { id: 4, descricao: 'ATIVO' },
                { id: 5, descricao: 'INATIVO' },
                { id: 6, descricao: 'INDEFERIDO' },
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODAS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', Number(event.target.value));
        }
    }
}
</script>